module.exports = __webpack_public_path__ + "img/rektek.51218beb.png";